import { BaseErrorCode, ErrorCode, UsageLogLineErrorCode } from './error-code.enum';

export const errorMessageMap: Partial<Record<BaseErrorCode, string>> = {
  [ErrorCode.CUSTOMER_COUNTRY_NOT_DEFINED]: 'Customer country not defined',
  [ErrorCode.COUNTRY_NAME_NOT_MAPPED]: 'Country name not mapped',
  [ErrorCode.BILLING_CYCLE_NOT_SUPPORTED]: 'Billing cycle not supported',
  [ErrorCode.FAILED_TO_SEND_CREDIT]: 'Failed to send credit',
  [ErrorCode.CONTRACT_CUSTOMER_USAGE_DATES_OVERLAP]:
    'Cannot publish contract with overlapping billing dates for same customer and usage product',
};

export const usageLogLineErrorMessageMap: Record<UsageLogLineErrorCode, string> = {
  [ErrorCode.USAGE_LOG_DATE_INVALID]: 'Date invalid',
  [ErrorCode.USAGE_LOG_DOCUMENT_NOT_FOUND]: 'Document not found',
  [ErrorCode.USAGE_LOG_ENTITY_DIFFERENT_IN_DOCUMENT]: 'Document uses a different entity',
  [ErrorCode.USAGE_LOG_QUANTITY_INVALID]: 'Invalid quantity',
  [ErrorCode.USAGE_LOG_CURRENCY_DIFFERENT_IN_DOCUMENT]: 'Document uses a different currency',
  [ErrorCode.USAGE_LOG_CONTRACT_PO_DIFFERENT_IN_DOCUMENT]: 'Document contract PO number is different',
  [ErrorCode.CUSTOMER_NOT_FOUND]: 'Customer not found',
  [ErrorCode.USAGE_PRODUCT_NOT_FOUND]: 'Usage product not found',
  [ErrorCode.SUPPLIER_NOT_FOUND]: 'Entity not found',
  [ErrorCode.CURRENCY_NOT_FOUND]: 'Currency not found',
};
